import { Checkbox } from '@mui/material';

interface CourseMappingCheckboxCellProps {
  checked: boolean;
  label: string;
  onToggle: () => void;
}

const CourseMappingCheckboxCell = ({ checked, label, onToggle }: CourseMappingCheckboxCellProps) => (
  <Checkbox
    checked={checked}
    size="small"
    className="course-mapping-checkbox"
    onChange={onToggle}
    inputProps={{ 'aria-label': label }}
  />
);

export default CourseMappingCheckboxCell;
